module.exports = __webpack_public_path__ + "img/circle5.5dee2280.gif";